import {createRouter, createWebHistory} from 'vue-router'
import Applayout from "@/layout/app";
import { useAuthStore } from '@/stores';

const routes = [
    {
        path: "/",
        component: Applayout,
        children: [
            {
                path: "/place",
                name: "전산DB",
                component: () => import("./views/app/place"),
                meta: { auth: true, title: '전산 DB', subTitle:'', requiresGuest: false, admin : false,
                    metaTags: [
                        { name: 'title', content: '전산DB' },
                        { name: 'description', content: '전산DB' },
                    ] }
            },
            {
                path: "/register",
                name: "중복DB",
                component: () => import("./views/app/register"),
                meta: { auth: true, title: '중복 DB', subTitle:'', requiresGuest: false, admin : false,
                    metaTags: [
                        { name: 'title', content: '중복DB' },
                        { name: 'description', content: '중복DB' },
                    ] }
            },
            {
                path: "/collect",
                name: "수집DB",
                component: () => import("./views/app/collect"),
                meta: { auth: true, title: '수집 DB', subTitle:'', requiresGuest: false, admin : false,
                    metaTags: [
                        { name: 'title', content: '수집DB' },
                        { name: 'description', content: '수집DB' },
                    ] }
            },
            {
                path: "/collect2",
                name: "수집DB2",
                component: () => import("./views/app/collect2"),
                meta: { auth: true, title: '수집 DB2', subTitle:'', requiresGuest: false, admin : false,
                    metaTags: [
                        { name: 'title', content: '수집DB2' },
                        { name: 'description', content: '수집DB2' },
                    ] }
            },
            {
                path: "/myDB",
                name: "MyDB",
                component: () => import("./views/app/myDB"),
                meta: { auth: true, title: 'My DB', subTitle:'', requiresGuest: false, admin : false,
                    metaTags: [
                        { name: 'title', content: 'MyDB' },
                        { name: 'description', content: 'MyDB' },
                    ] }
            },
            {
                path: "/manageUser",
                name: "회원관리",
                component: () => import("./views/app/manageUser"),
                meta: { auth: true, title: '회원 관리', subTitle:'', requiresGuest: false, admin : true,
                    metaTags: [
                        { name: 'title', content: '회원관리' },
                        { name: 'description', content: '회원관리' },
                    ] }
            },
            {
                path: "/",
                name: "로그인",
                component: () => import("./views/app/login"),
                meta: { auth: false, title: '로그인', subTitle:'', requiresGuest: true,
                    metaTags: [
                        { name: 'title', content: '로그인' },
                        { name: 'description', content: '로그인' },
                    ] }
            },
            {
                path: "/logout",
                name: "로그아웃",
                component: () => import("./views/app/logout"),
                meta: { auth: true, title: '로그아웃', subTitle:'', admin : false,
                    metaTags: [
                        { name: 'title', content: '로그아웃' },
                        { name: 'description', content: '로그아웃' },
                    ] }
            },
        ]
    },
    {
        path: "/:pathMatch(.*)*",  // 모든 경로를 처리
        redirect: "/"  // 잘못된 경로는 메인 페이지로 리디렉션
    }
]

const router = createRouter({
    history: createWebHistory(),  // HTML5 History 모드를 사용하여 # 없이 경로 처리
    routes,  // 라우트 배열 전달
    scrollBehavior() {
        return { x: 0, y: 0 };  // 페이지가 로드될 때 스크롤 위치를 (0, 0)으로 설정
    },
});



router.beforeEach(async (to,from, next) => {
    Array.from(document.querySelectorAll('[data-vue-meta]')).forEach(el => el.remove());

    if (to.meta.metaTags) {
        to.meta.metaTags.forEach(tag => {
            const metaTag = document.createElement('meta');
            Object.keys(tag).forEach(key => {
                const content = tag[key];
                metaTag.setAttribute(key, content);
            });
            metaTag.setAttribute('data-vue-meta', 'true'); // 중복 방지
            document.head.appendChild(metaTag);
        });
    }

    const authStore = useAuthStore();

    // 사용자 정보 설정이 완료되지 않았다면, 정보를 먼저 받아옴
    if (!authStore.user) {
        await authStore.setupUser();
    }

    if (to.meta.auth == true && to.meta.admin == true && authStore.grade != "ADMIN") {
        next('/')
        return
    }

    if (to.meta.auth == true && (authStore.accessToken == null|| !authStore.accessToken)) {
        next('/')
        return
    }
    if (to.matched.some(record => record.meta.requiresGuest)) {
        // 이미 인증된 사용자가 로그인 페이지에 접근하면 홈 페이지로 리디렉션
        if (authStore.accessToken != null && authStore.accessToken) {
            return next('/place');
        }
    }
    if(to.meta.auth == false || to.meta.auth ==undefined){
        next()
        return
    }
    return next()
});

export default router;